/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="a5cac2b8-2b0a-43e8-ac13-ebaeb8b2cd90" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="bbda3745-9a8e-4cbe-a69a-c076c866fd7a" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="b77f81d0-369d-4eeb-80a2-9b67cb2a3603">
              <path id="bb6d2bdb-95e6-4188-b710-9f59712c51a4" d="M17.79,3V22H5V3Zm-1,1H6V21H16.78ZM15.48,14.7v4.75H13.82V14.7Zm-3.29,3.16v1.59H10.53V17.86Zm-3.26,0v1.59H7.27V17.86Zm3.26-3.16v1.6H10.53V14.7Zm-3.26,0v1.6H7.27V14.7Zm6.55-3.16v1.6H13.82v-1.6Zm-3.29,0v1.6H10.53v-1.6Zm-3.26,0v1.6H7.27v-1.6Zm6.55-6.27v5.06H7.27v-5Zm-1,1H8.27V9.33h6.21Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="ab819ced-5f60-4f74-b2c4-90d03d03e1eb">
          <g id="afafb40c-622c-4906-ab80-ffeaf780ab21">
            <g id="bd6db26b-5e06-4fbf-a331-ffedee5c79e3">
              <path id="b6dd3324-3388-487e-a3f7-cc0b21bc692a" d="M17.79,3V22H5V3Zm-1,1H6V21H16.78ZM15.48,14.7v4.75H13.82V14.7Zm-3.29,3.16v1.59H10.53V17.86Zm-3.26,0v1.59H7.27V17.86Zm3.26-3.16v1.6H10.53V14.7Zm-3.26,0v1.6H7.27V14.7Zm6.55-3.16v1.6H13.82v-1.6Zm-3.29,0v1.6H10.53v-1.6Zm-3.26,0v1.6H7.27v-1.6Zm6.55-6.27v5.06H7.27v-5Zm-1,1H8.27V9.33h6.21Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#bbda3745-9a8e-4cbe-a69a-c076c866fd7a)' }}>
              <g id="a29f50a0-60dd-4345-bc4a-f0b50bd1eee2">
                <rect id="ec12f910-c6a3-4604-80ec-8501bd81306f" width="24" height="24" fill="#002b49" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#bbda3745-9a8e-4cbe-a69a-c076c866fd7a)' }}>
              <rect id="eef7728d-cde9-4bb8-8c82-94ca73560e5d" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CalculatorIcon';

export default Icon;
